
export default function testimonialsTeam () {

	const tabs = document.querySelectorAll('section.testimonials-team button');

	if (! tabs.length) return;



	const selectElement = document.querySelector('select');
	const tabButtons = document.querySelectorAll('[role="tab"]');
	
	// When select changes, click the corresponding tab button
	if (selectElement) {
		selectElement.addEventListener('change', function() {
			const selectedValue = this.value;
			const correspondingButton = Array.from(tabButtons).find(btn => {
				const dataTarget = btn.getAttribute('data-tabs-target');
				return dataTarget && dataTarget.includes(selectedValue);
			});
			
			if (correspondingButton) {
				correspondingButton.click();
			}
		});
	}
	
	// When a tab button is clicked, update select value
	tabButtons.forEach(button => {
		button.addEventListener('click', function() {
			const dataTarget = this.getAttribute('data-tabs-target');
			// Extract everything after "#quote-content-"
			const match = dataTarget.match(/#quote-content-(.+)$/);
			if (match && selectElement) {
				selectElement.value = match[1];
			}
		});
	});

}

/*
	ACF Blocks v3 re-fetches and re-renders this block's preview markup
	inside the editor (eg. on selection/attribute change) without a page
	reload, so 'DOMContentLoaded' only covers the first render - re-run init
	on every preview refresh too (the actual tab-panel switching is Flowbite's
	own data-tabs-toggle behaviour, re-armed generically in blocks.js).
	ACF's block-preview JS runs in the outer admin window, while this script
	runs inside the iframe, so check both.
*/
const acfInstance = (typeof window !== 'undefined')
	? (window.acf || (window.parent !== window && window.parent.acf))
	: null
;

if (acfInstance) {
	acfInstance.addAction('render_block_preview/type=testimonials-team', testimonialsTeam);
}
